import $ from 'jquery';

$(function () {
    // Function to close the modal
    function closeModal() {
        const modal = $('.fa-modal.carousel-triggered-modal');
        modal.fadeOut(() => {
            modal.removeClass('carousel-triggered-modal');
            $(document).trigger('modalClosed'); // Trigger custom event when modal is closed
        });
    }

    // Close modal when the close button is clicked
    $(document).on('click', '.js-modal-close', closeModal);

    // Close modal when clicking outside the modal content
    $(document).on('click', function (e) {
        const modalContainer = $('.fa-modal.carousel-triggered-modal .container'); // Modal content container
        if (!modalContainer.is(e.target) && modalContainer.has(e.target).length === 0) {
            closeModal();
        }
    });

    // Prevent click event from propagating to the document when clicking inside the modal
    $(document).on('click', '.fa-modal.carousel-triggered-modal .container', function (e) {
        e.stopPropagation();
    });

    // Function to add "See More" link if content exceeds 88px in height
    function addSeeMoreLink() {
        $('.membership-slide-card__text').each(function () {
            const $list = $(this);
            const $listItems = $list.find('.list-item');
            let cumulativeHeight = 0;
            let lastVisibleIndex = 0;

            // Avoid adding multiple "See More" links to the same list
            if ($list.find('.see-more').length > 0) {
                return;
            }

            // Calculate the visible height of list items
            $listItems.each(function (index) {
                cumulativeHeight += $(this).outerHeight(true);
                if (cumulativeHeight <= 88) {
                    lastVisibleIndex = index;
                } else {
                    return false; // Stop iteration when the height exceeds 88px
                }
            });

            if (cumulativeHeight > 88) {
                // Hide items after the visible threshold
                $listItems.slice(lastVisibleIndex + 1).hide();

                // Add a "See More" link after the last visible item
                const seeMoreLink = $('<a href="javascript:void(0)" class="see-more">see more</a>');
                $listItems.eq(lastVisibleIndex).append(seeMoreLink);

                // Event handler for "See More" click to open modal
                seeMoreLink.on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation(); // Prevent the click event from propagating

                    // Prevent carousel sliding during modal opening
                    $('.membership-card-wrapper .carousel-container').off('touchstart touchmove touchend');

                    $('.fa-modal').addClass('carousel-triggered-modal').fadeIn();

                    // Remove the modal title if not required
                    $('.js-modal-title').text('');

                    // Clone the ENTIRE card body (including all hidden content)
                    const fullContent = $list.closest('.membership-slide-card__body').clone();
                    fullContent.find('.see-more').remove(); // Remove the "See More" link completely
                    fullContent.find('.list-item').show(); // Ensure all list items are visible

                    // Add "See Less" link to the last list item's text content
                    const lastListItem = fullContent.find('.list-item').last();
                    const seeLessLink = $('<a href="javascript:void(0)" class="see-less"> see less</a>'); // Create See Less link
                    lastListItem.append(seeLessLink); // Append See Less to the end of the last list item's text

                    $('.js-modal-contents').html(fullContent); // Inject the cloned content into the modal

                    // Bind event for "See Less" to close modal
                    $('.see-less').on('click', function (e) {
                        e.preventDefault();
                        closeModal();
                    });

                    // Rebind the close button event
                    $('.js-modal-close').off('click').on('click', closeModal);
                });
            }
        });
    }

    // Call the function initially to add "See More" links
    addSeeMoreLink();

    // Reapply the "See More" logic when dynamic content is loaded
    $(document).on('contentLoaded', addSeeMoreLink);

    // Function to set all card heights to be the same
    function setEqualCardHeight() {
        const cards = $('.membership-slide-card'); // Select all cards
        let maxHeight = 0;

        // Reset heights to auto to recalculate accurately
        cards.css('height', 'auto');

        // Calculate the maximum height among all cards
        cards.each(function () {
            const height = $(this).outerHeight();
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Apply the maximum height to all cards
        cards.css('height', `${maxHeight}px`);
    }

    // Call the function initially to ensure equal heights
    setEqualCardHeight();

    // Reapply the function on window resize for responsiveness
    $(window).on('resize', setEqualCardHeight);
});


// WEBPACK FOOTER //
// ./components/cw-membership-slider/scripts/membership-slider-card.js